import * as types from './special.types';

export const fetchSpecialRequest = params => ({ type: types.FETCH_SPECIAL_REQUEST, params });
export const fetchSpecialSuccess = data => ({ type: types.FETCH_SPECIAL_SUCCESS, data });
export const fetchSpecialFailure = error => ({ type: types.FETCH_SPECIAL_FAILURE, error });
